import React, { Fragment, useEffect, useState, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

import LoadingContext from '../../context/Loading/Loading'

import { getMyAccessPass } from '../../utilities/api'

import {
  AccessPassDetailsWrapper,
  PageLoadingContainer,
} from '../../components'

export default function AccessPassDetailsPage() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)
  const { uuid } = useParams()
  const navigate = useNavigate()
  const [accessPass, setAccessPass] = useState()

  useEffect(() => {
    const fetchData = async () => {
      try {
        showLoading()
        const res = await getMyAccessPass(uuid)
        setAccessPass(res?.data?.data)
      } catch (err) {
        console.error(err)
      } finally {
        hideLoading()
      }
    }

    if (uuid) {
      fetchData()
    }
  }, [uuid])

  return (
    <Fragment>
      <Helmet>
        <title>{accessPass?.name || 'Access Pass'} | Blocktickets</title>
      </Helmet>
      {isLoading ? (
        <PageLoadingContainer />
      ) : accessPass ? (
        <section className="background-gradient pt-4">
          <AccessPassDetailsWrapper
            accessPass={accessPass}
            onTransferred={() => navigate('/my-events')}
          />
        </section>
      ) : (
        <section className="background-gradient pt-4 spacer-xs">
          <p>Access pass not found.</p>
        </section>
      )}
    </Fragment>
  )
}
